import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import PersonIcon from '@mui/icons-material/Person';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';

export const ProfileSidebarItem = () => {
  const identityApi = useApi(identityApiRef);
  const [userEntityRef, setUserEntityRef] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchUserEntityRef = async () => {
      try {
        const userIdentity = await identityApi.getBackstageIdentity();
        if (userIdentity.userEntityRef) {
          setUserEntityRef(userIdentity.userEntityRef);
        }
      } catch (error) {
        console.error('Failed to get user identity:', error);
      }
    };

    fetchUserEntityRef();
  }, [identityApi]);

  // Convert entity reference to catalog URL
  // userEntityRef format is typically: "user:default/username"
  const getProfileUrl = (entityRef: string) => {
    const parts = entityRef.split(':');
    if (parts.length === 2) {
      const [kind, namespaceAndName] = parts;
      const [namespace, name] = namespaceAndName.includes('/') 
        ? namespaceAndName.split('/') 
        : ['default', namespaceAndName];
      return `/catalog/${namespace}/${kind.toLowerCase()}/${name}`;
    }
    // Fallback to catalog if parsing fails
    return '/catalog';
  };

  const profileUrl = userEntityRef ? getProfileUrl(userEntityRef) : '/catalog';

  return (
    <SidebarItem 
      icon={PersonIcon} 
      to={profileUrl} 
      text="Profile"
    />
  );
};